// extracted by mini-css-extract-plugin
export default {"artCategoriesContainer":"styles_artCategoriesContainer__C1bSX","moreBanner":"styles_moreBanner__RQ9f5"};